import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FormatNumber } from "../../../Component/FormatNumber/FormatNumber";
import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL } from "../../../Apis/BaseUrl";
const ConfirmActionModal = ({
  show,
  handleClose,
  actionType,
  selectedItem,
  onConfirm,
}) => {
  const [reason, setReason] = useState("");

  const handleStatusAPI = async (id, status) => {
    try {
      const token = JSON.parse(
        localStorage.getItem("v&b_token") || Cookies.get("v&b_token")
      ).token;
      const res = await axios.put(
        `${BASE_URL}/franchise/withdrawal-requests-franchise/${id}/status`,
        { status, reasonForReject: status === "rejected" ? reason : undefined },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        onConfirm();
      }
    } catch (error) {
      alert("Failed to update status");
    }
    handleClose();
  };

  const handleConfirm = () => {
    if (actionType === "accept") {
      handleStatusAPI(selectedItem?._id, "approved");
    } else {
      handleStatusAPI(selectedItem?._id, "rejected");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {actionType === "accept" ? "Confirm Approval" : "Confirm Rejection"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <div
            className={`alert ${
              actionType === "accept" ? "alert-success" : "alert-danger"
            }`}
          >
            <h6 className="mb-3">
              Are you sure you want to{" "}
              {actionType === "accept" ? "approve" : "reject"} this withdrawal
              request?
            </h6>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="row mb-2">
                <div className="col-6 text-start">
                  <strong>Franchise:</strong>
                </div>
                <div className="col-6 text-end text-capitalize">
                  {selectedItem?.franchise?.name ||
                    selectedItem?.franchiseId?.name}
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-6 text-start">
                  <strong>Amount:</strong>
                </div>
                <div className="col-6 text-end">
                  {FormatNumber(selectedItem?.amount || 0)}
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-6 text-start">
                  <strong>Available Balance:</strong>
                </div>
                <div className="col-6 text-end">
                  {FormatNumber(selectedItem?.availableBalance ?? 0)}
                </div>
              </div>
              {(selectedItem?.notes || selectedItem?.message) && (
                <div className="row">
                  <div className="col-12">
                    <strong>Notes:</strong>
                    <div
                      className="text-muted small mt-1"
                      style={{
                        maxHeight: "60px",
                        overflowY: "auto",
                        textAlign: "left",
                      }}
                    >
                      {selectedItem?.notes || selectedItem?.message}
                    </div>
                  </div>
                </div>
              )}
              {actionType === "reject" && (
                <div className="row mt-2">
                  <div className="col-12">
                    <label htmlFor="reason" className="form-label">
                      Reason for Rejection
                    </label>
                    <textarea
                      id="reason"
                      className="form-control"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      rows={2}
                      placeholder="Enter reason (optional)"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="mt-3">
            <small className="text-muted">
              This action cannot be undone. Please make sure you want to
              proceed.
            </small>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant={actionType === "accept" ? "success" : "danger"}
          onClick={handleConfirm}
        >
          {actionType === "accept" ? "Approve Request" : "Reject Request"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmActionModal;
